import { render, staticRenderFns } from "./modalFinalizarPedido.vue?vue&type=template&id=0d95f848&scoped=true"
import script from "./modalFinalizarPedido.vue?vue&type=script&lang=js"
export * from "./modalFinalizarPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d95f848",
  null
  
)

export default component.exports